import { MultiProductPriceUpsertPayload, ProductPriceWithProductInfo } from "../../common/types/productPrice"
import PriceLevel from "../../state/price-level/PriceLevel"
import ProductPrice from "../../state/product-price/ProductPrice"
import { 
    CreateMultiProductPricePayload, 
    CreateMultiProductPriceWithProductIdPayload, 
    ProductPriceWithName 
} from "../../state/product-price/types"

const createNewMultiProductPricePayload =
    (productPriceMap: Map<string, ProductPriceWithName>): CreateMultiProductPricePayload[] | void => {
        const payload = Array.from(productPriceMap.entries()).map(([priceLevelId, productPrice]) => {
            if (productPrice.price || productPrice.toBeArchived) {
                return {
                    id: productPrice.id,
                    priceLevelId: priceLevelId.toString(),
                    price: productPrice.price,
                    toBeArchived: productPrice.toBeArchived
                }
            }
        }).filter((item): item is CreateMultiProductPricePayload => item !== undefined)

        return payload || []
    }

const createNewProductPriceWithName = (productPrice: ProductPrice): ProductPriceWithName => {
    return {
        id: productPrice.getId(),
        name: productPrice.getPriceLevelName(),
        price: productPrice.isArchived() ? undefined : productPrice.getPrice().toString(),
        priceLevelId: productPrice.getPriceLevelId(),
        externalLinks: productPrice.priceLevel.getExternalLinks(),
        toBeArchived: false,
        isArchived: productPrice.isArchived(),
        recentlyModified: false
    }
}

const createMultiProductPricePayload =
    (items: ProductPriceWithProductInfo[]): CreateMultiProductPriceWithProductIdPayload[] | void => {
        const payload = items.map(item => {
            if (item.recentlyModified) {
                return {
                    id: item.id,
                    productId: item.productId,
                    priceLevelId: item.priceLevelId,
                    price: item.price.toString() || undefined,
                    toBeArchived: item.toBeArchived
                }
            }
        }).filter((item): item is CreateMultiProductPriceWithProductIdPayload => item !== undefined)

        return payload || []
    }

export const multiProductPriceCreatePayload = (
    productIds: string[],
    priceLevelId: string
): MultiProductPriceUpsertPayload => {
    return  {
        productPrices: productIds.map((productId) => {
            return {
                productId: productId,
                priceLevelId: priceLevelId,
                price: "0"
            }
        })
    }
}

const matchPriceLevelsWithProductPrice =
    (productPrices: ProductPrice[], priceLevels: PriceLevel[]): Map<string, ProductPriceWithName> => {
        const priceLevelsById: Map<string, ProductPriceWithName> = new Map < string, ProductPriceWithName> ()
        for (const level of priceLevels) {
            //have the name of the price level even if a productPrice doesn't exist yet
            priceLevelsById.set(level.getId(),
                { name: level.getName(), externalLinks: level.externalLinks } as ProductPriceWithName)
        }

        if (productPrices && productPrices.length > 0) {
            for (const productPrice of productPrices) {
                const priceLevelId = productPrice.getPriceLevelId()
                if (priceLevelsById.has(priceLevelId)) {
                    // If it exists, create a new ProductPriceWithName object associated with it
                    priceLevelsById.set(priceLevelId, createNewProductPriceWithName(productPrice))
                }
            }
        }
        return priceLevelsById
    }

export {
    createNewProductPriceWithName,
    matchPriceLevelsWithProductPrice,
    createNewMultiProductPricePayload,
    createMultiProductPricePayload,
}


// WEBPACK FOOTER //
// ./src/utils/product-price/utils.ts